import CustomSelect from "@Common/CustomSelect"
import Input from "@Common/input"
import { PhoneNumberField } from "@Common/PhoneNumberField"
import { useGetGetTeamMemberRoles } from "@services"
import { isValidPhone } from "@utils"
import { useMemo } from "react"
import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"

export default function FormInputsNewMember() {
	const { t } = useTranslation()
	const { control } = useFormContext()
	const { data } = useGetGetTeamMemberRoles({})
	/* ---------------------------------- Hooks --------------------------------- */
	const {
		i18n: { language },
	} = useTranslation()

	const listOfPremissions = useMemo(() => {
		const dataList = data?.result.map((item) => {
			return {
				label: language === "en" ? item.roleName : item.roleNameAr,
				value: item.roleId.toString(),
			}
		})
		return dataList ?? []
	}, [data, language])
	return (
		<div>
			<Input
				label={t("UserManagement.name")}
				placeholder={t("UserManagement.name")}
				name='fullName'
				registerOptions={{
					required: {
						value: true,
						message: t("COMMON.REQUIRED"),
					},
				}}
			/>
			<Input
				label={t("UserManagement.email")}
				placeholder={t("UserManagement.email")}
				name='email'
				type="email"
				registerOptions={{
					required: {
						value: true,
						message: t("COMMON.REQUIRED"),
					},
					pattern: {
						value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
						message: t("UserManagement.please_enter_valid_email") || "Please enter a valid email address",
					},
				}}
			/>
			<Controller
				name='phoneNumber'
				control={control}
				rules={{
					required: t("COMMON.REQUIRED"),
					validate: (value) =>
						isValidPhone(value) ||
						t("UserManagement.please_enter_the_mobile_number_correctly"),
				}}
				render={({
					field: { value, onChange, onBlur },
					fieldState: { error },
				}) => (
					<PhoneNumberField
						value={value}
						onChange={onChange}
						onBlur={onBlur}
						required
						label={t("UserManagement.phone_number")}
						placeholder={t("UserManagement.phone_number")}
						error={error?.message ? t(error.message) : undefined}
					/>
				)}
			/>
			<CustomSelect
				data={listOfPremissions}
				label={t("UserManagement.team_member_role")}
				name='roleId'
				registerOptions={{
					required: {
						value: true,
						message: t("COMMON.REQUIRED"),
					},
				}}
			/>
		</div>
	)
}
